import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Col } from 'reactstrap';
import { getMantenedores } from '../../../shared/helpers/api/apiCall';

export const DriverSelect = ({ driverList, setDriverList, selectedDriver, setSelectedDriver, user }) => {
    
    useEffect(() => {
        const fetchDriverList = async () => {
            try {
                const response = await getMantenedores('conductores', user);
                const formattedData = response.conductores.map(item => ({
                    value: `${item.usuarioSpread} - ${item.ppu}`,
                    label: item.usuario_movil_id
                }));
                setDriverList(formattedData);
            } catch (error) {
                console.error(error);
            }
        };
        fetchDriverList();
    }, [setDriverList]);

    const handleConductorSelect = (event, value) => {
        const selectedOption = driverList.find(option => option.value === value);
        if (selectedOption) {
            setSelectedDriver({ id: selectedOption.label, value: selectedOption.value });
        } else {
            setSelectedDriver({ id: '', value: '' });
        }
    };

    return (
        <Col>
            <Autocomplete
                className='mb-2'
                id='conductores-select'
                freeSolo
                options={driverList.map((option) => option.value)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label="Seleccionar Conductor"
                    />
                }
                onChange={handleConductorSelect}
                value={selectedDriver.value || ''}
            />
        </Col>
    );
};